<div class="yasc-dialog-title">
    <p>{{ 'timeClock'|translate:locale.language }}</p>
</div>
<mat-dialog-content style="width: 25vw">
    <div class="timerGrid">
        <div class="sectionList">
            <div class="itemWrapper mat-elevation-z1" *ngFor="let section of timeClock.sections;let i = index">
                <div class="sectionItem ">
                    {{ time(section.duration) }}
                    <mat-icon style="cursor: pointer" (click)="toDelete=i">close</mat-icon>
                </div>
                <div *ngIf="toDelete === i" class="confirmation" [@inOutAnimation]>
                    {{ 'sicher?' }}
                    <div style="display:flex; flex-direction: row">
                        <mat-icon style="cursor: pointer" (click)="timeClock.removeSection(i)">check</mat-icon>
                        <mat-icon style="cursor: pointer" (click)="toDelete = null">close</mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <h1>{{ time(currentTimer!) }}</h1>
        </div>
        <span style="width: 100%"></span>
    </div>
    <div class="projectCombo">
        <yasc-combobox
                [yascDisabled]="timeClock.isTimerRunning"
                [yascLabel]="('project'|translate:locale.language)!"
                [(yascModel)]="timeClock.selectedProject"
                (yascModelChange)="getTasks($event)"
                [yascOptions]="projects"
                [yascCompare]="compare">
        </yasc-combobox>
        <yasc-combobox
                [yascDisabled]="tasks.length === 0"
                [yascLabel]="('task'|translate:locale.language)!"
                [(yascModel)]="timeClock.selectedTasks"
                [yascOptions]="tasks"
                [yascCompare]="compare">
        </yasc-combobox>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div style="display: flex;width: 100%; justify-content: space-between">
        <div>
            <button mat-stroked-button
                    [disabled]="timeClock.selectedTasks === null"
                    (click)="timeClock.isTimerRunning ? timeClock.pauseTimer() : timeClock.startTimer()">
                <mat-icon>{{ !timeClock.isTimerRunning ? 'play_arrow' : 'pause' }}</mat-icon>
                {{ (!timeClock.isTimerRunning ? 'start' : 'pause')|translate:locale.language }}
            </button>

            <button mat-stroked-button
                    (click)="timeClock.stopTimer()"
                    [disabled]="timeClock.sections.length === 0 && !timeClock.isTimerRunning">
                <mat-icon>stop</mat-icon>
                {{ 'stop'|translate:locale.language }}
            </button>
        </div>
        <button [disabled]="disableSave()"
                mat-raised-button
                (click)="timeClock.save()"
                color="accent">
            <mat-icon>save</mat-icon>
            {{ 'generalSave'|translate:locale.language }}
        </button>
    </div>
</mat-dialog-actions>